/** Root overlay ids and aria; HUD content comes from the React store. */
export const FRUIT_NINJA_REMOTE_DOM = {
  root: 'fruit-remote-ui',
  pauseRoot: 'fruit-remote-pause',
  pauseTitle: 'fruit-remote-pause-title',
  gameOverRoot: 'gameover',
  restartBtn: 'restart-btn',
} as const;
